export const PAGE_SIZE_OPTIONS = ['10', '25', '50', '100'];

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

const normalizeText = (value) => String(value ?? '').trim();

export const formatAffectedFileDetailDate = (value) => {
  if (!value) {
    return 'Unknown date';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return normalizeText(value) || 'Unknown date';
  }

  return DATE_TIME_FORMATTER.format(date);
};

export const normalizeAffectedFileDetail = (item, index = 0) => ({
  key:
    item?.committed_item_id ??
    item?.rn ??
    `${normalizeText(item?.bug_id) || 'affected-file-detail'}-${index + 1}`,
  bugId: normalizeText(item?.bug_id),
  bugUrl: normalizeText(item?.bug_url),
  filePath: normalizeText(item?.file_path),
  fileUrl: normalizeText(item?.file_url),
  rollout: normalizeText(item?.rollout) || 'Unknown rollout',
  action: normalizeText(item?.action) || 'Unknown',
  author: normalizeText(item?.author) || 'Unknown',
  commitDate: item?.commit_date ?? '',
  commitDateLabel: formatAffectedFileDetailDate(item?.commit_date),
  raw: item,
});
